// A paid meet date is a leisure service for a set date, so the 14-day right to
// cancel does not apply (Consumer Contracts Regulations 2013, reg 28(1)(b)),
// and the member must be told before they book. The owner (2 Oct 2026): keep it
// off the booking screen and put it at the top of the Cancellation terms dialog
// the booking step links to. Pure, so the app can mirror it word for word.
export const MEET_SET_DATE_CANCELLATION_LINE =
  "This is for a set date, so there's no 14-day right to cancel. You can still cancel under the club's terms below.";
